/* Run 06 batch 2 — Tart Cherry PDP. Vanilla JS, scoped by [data-tc-kind]. */
(function () {
  "use strict";
  if (window.__tcPdpScan) {
    window.__tcPdpScan(document);
    return;
  }

  function money(cents) {
    var n = Math.round(Number(cents) || 0);
    return "$" + (n / 100).toFixed(2);
  }
  function pad(n) {
    return String(n).padStart(2, "0");
  }
  function parseConfig(el) {
    var raw = el.getAttribute("data-tc-config");
    if (!raw) return {};
    try { return JSON.parse(raw); } catch (e) { return {}; }
  }
  function addDays(date, days) {
    var d = new Date(date.getTime());
    d.setDate(d.getDate() + Number(days || 0));
    return d;
  }
  function ordinal(n) {
    var v = n % 100;
    if (v >= 11 && v <= 13) return n + "th";
    switch (n % 10) {
      case 1: return n + "st";
      case 2: return n + "nd";
      case 3: return n + "rd";
      default: return n + "th";
    }
  }
  function formatLongDate(d) {
    var months = ["January","February","March","April","May","June","July","August","September","October","November","December"];
    return months[d.getMonth()] + " " + ordinal(d.getDate());
  }
  function parseDay(str) {
    if (!str) return null;
    var p = String(str).split("-");
    if (p.length < 3) return null;
    return new Date(Number(p[0]), Number(p[1]) - 1, Number(p[2]), 23, 59, 59, 999);
  }
  function parseStart(str) {
    if (!str) return null;
    var p = String(str).split("-");
    if (p.length < 3) return null;
    return new Date(Number(p[0]), Number(p[1]) - 1, Number(p[2]), 0, 0, 0, 0);
  }
  function parseMoneySetting(str) {
    if (str == null || str === "") return 0;
    var n = String(str).replace(/[^0-9.]/g, "");
    if (!n) return 0;
    if (n.indexOf(".") === -1 && Number(n) >= 1000) return Number(n);
    return Math.round(Number(n) * 100);
  }

  // Advertorial offer mode (B07): the advertorial CTA appends ?offer=reader67. Everything else is the plain PDP.
  function offerOn() {
    try { return new URLSearchParams(window.location.search).get("offer") === "reader67"; } catch (e) { return false; }
  }
  // Offer mode clock: on a visitor's first offer-mode PDP view a window of a random 41h-67h (random min/sec) is started and survives reloads (localStorage).
  // The top bar and the discount bar read the same window. At 0 a fresh random 41h-67h window starts, so the clock never shows 00:00:00 or negative.
  var OFFER_MIN_MS = 41 * 3600 * 1000;
  var OFFER_MAX_MS = 67 * 3600 * 1000;
  var OFFER_KEY = "tc_offer_reader67_end_v2";
  var offerEndMem = 0;
  function offerRemainingMs() {
    var now = Date.now();
    var end = offerEndMem;
    try { end = Number(window.localStorage.getItem(OFFER_KEY)) || end; } catch (e) {}
    if (!end || end <= now || end - now > OFFER_MAX_MS + 5000) {
      end = now + OFFER_MIN_MS + Math.floor(Math.random() * ((OFFER_MAX_MS - OFFER_MIN_MS) / 1000 + 1)) * 1000;
      try { window.localStorage.setItem(OFFER_KEY, String(end)); } catch (e) {}
    }
    offerEndMem = end;
    return end - now;
  }
  function hms(ms) {
    var t = Math.max(0, Math.ceil(ms / 1000));
    return { h: Math.floor(t / 3600), m: Math.floor((t % 3600) / 60), s: t % 60 };
  }

  function boot(root) {
    if (!root || root.dataset.tcBooted === "1") return;
    root.dataset.tcBooted = "1";
    var kind = root.getAttribute("data-tc-kind");
    if (kind === "timer") initTimer(root);
    else if (kind === "hero") initHero(root);
    else if (kind === "header") initHeader(root);
    else if (kind === "acc") initAccordions(root);
    else if (kind === "benefits") initAccordions(root);
    else if (kind === "faq") initAccordions(root);
    else if (kind === "wall") initWall(root);
    else if (kind === "reasons") initReasons(root);
    else if (kind === "sticky") initSticky(root);
  }

  function initHeader(root) {
    initNavAnchors(root);
    var btn = root.querySelector("[data-tc-menu]");
    var id = btn && btn.getAttribute("aria-controls");
    var drawer = id ? document.getElementById(id) : document.querySelector("[data-tc-drawer]");
    if (!btn || !drawer) return;
    // The header section is a sticky z-index:40 stacking context; the drawer lives on <body> so it covers the page.
    if (drawer.parentNode !== document.body) {
      // theme-editor re-render: drop the drawer an earlier render moved to <body>
      Array.prototype.forEach.call(document.querySelectorAll("body > [data-tc-drawer]"), function (el) {
        if (el.id === id) el.remove();
      });
      document.body.appendChild(drawer);
    }
    var panel = drawer.querySelector(".tc-drawer__panel") || drawer;
    var reduce = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    var hideTimer = 0;
    function isOpen() { return drawer.classList.contains("is-open"); }
    function focusables() { return panel.querySelectorAll("a[href], button:not([disabled])"); }
    function open() {
      if (isOpen()) return;
      clearTimeout(hideTimer);
      drawer.removeAttribute("hidden");
      void drawer.offsetWidth; // commit the closed state so the slide-in transitions
      drawer.classList.add("is-open");
      document.documentElement.classList.add("tc-drawer-lock");
      btn.setAttribute("aria-expanded", "true");
      var closeBtn = panel.querySelector(".tc-drawer__close");
      (closeBtn || panel).focus();
    }
    function close(restoreFocus) {
      if (!isOpen()) return;
      drawer.classList.remove("is-open");
      document.documentElement.classList.remove("tc-drawer-lock");
      btn.setAttribute("aria-expanded", "false");
      hideTimer = setTimeout(function () { drawer.setAttribute("hidden", ""); }, reduce ? 0 : 260);
      if (restoreFocus !== false) btn.focus();
    }
    btn.addEventListener("click", function () { if (isOpen()) close(); else open(); });
    drawer.addEventListener("click", function (e) {
      if (e.target.closest("[data-tc-drawer-close]")) { close(); return; }
      var link = e.target.closest("a[href]");
      if (link) close(false);
    });
    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape" && isOpen()) { e.preventDefault(); close(); }
    });
    drawer.addEventListener("keydown", function (e) {
      if (e.key !== "Tab") return;
      var els = focusables();
      if (!els.length) return;
      var first = els[0];
      var last = els[els.length - 1];
      if (e.shiftKey && (document.activeElement === first || document.activeElement === panel)) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    });
    if (window.matchMedia) {
      var desktop = window.matchMedia("(min-width: 990px)");
      var onChange = function () { if (desktop.matches) close(false); };
      if (desktop.addEventListener) desktop.addEventListener("change", onChange);
      else if (desktop.addListener) desktop.addListener(onChange);
    }
    initNavAnchors(drawer);
  }

  // Same-page nav anchors (/#rh-ways on the home page): smooth-scroll to the section; scroll-margin-top on
  // the target clears the sticky header. Other pages follow the link normally.
  function initNavAnchors(scope) {
    if (!scope.querySelector(".tc-pdp-header__link, .tc-drawer__link")) return;
    scope.addEventListener("click", function (e) {
      var link = e.target.closest("a[href*='#']");
      if (!link || e.defaultPrevented || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
      var url;
      try { url = new URL(link.href, window.location.href); } catch (err) { return; }
      if (url.origin !== window.location.origin || url.pathname !== window.location.pathname || !url.hash) return;
      var target;
      try { target = document.getElementById(decodeURIComponent(url.hash.slice(1))); } catch (err) { return; }
      if (!target) return;
      e.preventDefault();
      var smooth = !(window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches);
      // let the drawer's click handler release the scroll lock first
      setTimeout(function () {
        target.scrollIntoView({ behavior: smooth ? "smooth" : "auto", block: "start" });
        try { history.pushState(null, "", url.hash); } catch (err) {}
      }, 0);
    });
  }

  function pickEvent(events) {
    var now = new Date();
    var active = [];
    var upcoming = [];
    var evergreen = null;
    events.forEach(function (ev) {
      var s = parseStart(ev.start);
      var e = parseDay(ev.end);
      if (!s || !e) return;
      if (ev.evergreen) evergreen = ev;
      if (s <= now && now <= e) active.push(ev);
      else if (s > now) upcoming.push(ev);
    });
    if (active.length) {
      active.sort(function (a, b) {
        return (parseDay(a.end) - parseStart(a.start)) - (parseDay(b.end) - parseStart(b.start));
      });
      return active[0];
    }
    if (upcoming.length) {
      upcoming.sort(function (a, b) { return parseStart(a.start) - parseStart(b.start); });
      return upcoming[0];
    }
    return evergreen || events[0] || null;
  }

  function initTimer(root) {
    var titleEl = root.querySelector("[data-tc-event-title]");
    var events = [];
    var raw = root.getAttribute("data-tc-sale-events") || "[]";
    try { events = JSON.parse(raw); } catch (e) { events = []; }
    if (!Array.isArray(events)) events = [];
    var chosen = pickEvent(events);
    if (chosen && titleEl && chosen.name) titleEl.textContent = chosen.name;
    var offerText = root.getAttribute("data-tc-offer-text");
    if (titleEl && offerText && offerOn()) titleEl.textContent = offerText;
    var hrsEl = root.querySelector("[data-tc-hrs]");
    var minEl = root.querySelector("[data-tc-min]");
    var secEl = root.querySelector("[data-tc-sec]");
    var hrsLab = root.querySelector("[data-tc-hrs-label]");
    var minLab = root.querySelector("[data-tc-min-label]");
    var secLab = root.querySelector("[data-tc-sec-label]");
    var labHrs = root.getAttribute("data-tc-label-hrs") || "HRS";
    var labMins = root.getAttribute("data-tc-label-mins") || "MINS";
    var labSecs = root.getAttribute("data-tc-label-secs") || "SECS";
    if (hrsLab) hrsLab.textContent = labHrs;
    if (minLab) minLab.textContent = labMins;
    if (secLab) secLab.textContent = labSecs;
    function endOfLocalDay() {
      var d = new Date();
      d.setHours(24, 0, 0, 0);
      return d;
    }
    var offer = offerOn();
    function tick() {
      var parts;
      if (offer) parts = hms(offerRemainingMs());
      else {
        var totalSec = Math.floor(Math.max(0, endOfLocalDay().getTime() - Date.now()) / 1000);
        parts = { h: Math.floor(totalSec / 3600), m: Math.floor((totalSec % 3600) / 60), s: totalSec % 60 };
      }
      if (hrsEl) hrsEl.textContent = pad(parts.h);
      if (minEl) minEl.textContent = pad(parts.m);
      if (secEl) secEl.textContent = pad(parts.s);
    }
    tick();
    setInterval(tick, 1000);
  }

  function initHero(root) {
    var cfg = parseConfig(root);
    var variants = cfg.variants || {};
    var discount = Number(cfg.discountPercent || 0);
    var defaultId = String(cfg.defaultVariantId || "");
    var defaultSub = root.getAttribute("data-tc-default-subscribe") === "true";
    var savePrefix = root.getAttribute("data-tc-save-prefix") || "You save";
    var state = { variantId: defaultId, subscribe: defaultSub, planId: "" };
    // Variant pricing (offer-profile products): every price is the Shopify variant / selling-plan price; no offer mode.
    var variantPricing = cfg.variantPricing === true;
    var offer = offerOn() && !variantPricing;
    var offerBar = root.querySelector("[data-tc-offer-bar]");
    if (offer && offerBar) offerBar.removeAttribute("hidden");
    if (offer) root.classList.add("is-offer");
    var offerCountdown = offer && root.querySelector("[data-tc-offer-countdown]");
    if (offerCountdown) {
      var tickOffer = function () {
        var p = hms(offerRemainingMs());
        offerCountdown.textContent = pad(p.h) + ":" + pad(p.m) + ":" + pad(p.s);
      };
      tickOffer();
      setInterval(tickOffer, 1000);
    }
    var offerSubLabel = root.getAttribute("data-tc-offer-sub-label");
    var subTitle = root.querySelector("[data-tc-sub-toggle] .tc-hero__purchase-title");
    if (offer && offerSubLabel && subTitle) subTitle.textContent = offerSubLabel;
    // Savings are priced per bottle SHIPPED (paid + free): list = bottles x one single-bottle price.
    // Plain PDP: one-time single-bottle price. Offer mode: the advertorial's $89.99/bottle anchor.
    var singleCents = 0;
    Object.keys(variants).forEach(function (id) {
      if (Number(variants[id].bottles) === 1) singleCents = Number(variants[id].price || 0);
    });
    var baseCents = offer ? parseMoneySetting(root.getAttribute("data-tc-offer-anchor")) : singleCents;

    function planFor(id) {
      var v = variants[id] || {};
      return String(v.planId || cfg.sellingPlanId || "");
    }
    function packEl(id) {
      return root.querySelector('[data-tc-pack][data-variant-id="' + id + '"]');
    }
    function syncPlan() {
      var el = packEl(state.variantId) || root.querySelector("[data-tc-pack].is-selected");
      if (el) {
        state.variantId = el.getAttribute("data-variant-id") || state.variantId;
        state.planId = el.getAttribute("data-plan-id") || planFor(state.variantId);
      } else {
        state.planId = planFor(state.variantId);
      }
    }
    var bootPack = root.querySelector("[data-tc-pack].is-selected") || packEl(defaultId);
    if (bootPack) {
      state.variantId = bootPack.getAttribute("data-variant-id") || defaultId;
    }
    syncPlan();
    // Deep-link preselect (B07 advertorial CTA): ?variant=<id> picks the pack; ?selling_plan=<plan id> picks
    // the pack that owns that plan (unless ?variant is set) and switches the buy box to Subscribe when the
    // plan belongs to the chosen pack. No params = page default, unchanged.
    (function () {
      var q;
      try { q = new URLSearchParams(window.location.search); } catch (e) { return; }
      var qVariant = q.get("variant");
      var qPlan = q.get("selling_plan");
      var pickId = qVariant && variants[qVariant] ? qVariant : "";
      if (!pickId && qPlan) {
        Object.keys(variants).forEach(function (id) {
          if (!pickId && String(variants[id].planId || "") === qPlan) pickId = id;
        });
      }
      if (!pickId) return;
      state.variantId = pickId;
      if (qPlan && String(variants[pickId].planId || "") === qPlan) state.subscribe = true;
      syncPlan();
    })();

    var slides = root.querySelector("[data-tc-slides]");
    var slideEls = root.querySelectorAll("[data-tc-slide]");
    var thumbsWrap = root.querySelector(".tc-hero__thumbs");
    var origThumbs = thumbsWrap
      ? Array.prototype.slice.call(thumbsWrap.querySelectorAll("[data-tc-thumb]"))
      : [];
    var count = slideEls.length || origThumbs.length;
    var idx = 0;
    var thumbPos = 0;
    var thumbLoop = origThumbs.length;
    var stageOffset = 0;
    var thumbReseat = null;
    var thumbScrollTimer = 0;
    var stageReseat = null;
    var stageTimer = 0;

    if (slides && slideEls.length > 1) {
      var firstSlide = slideEls[0];
      var lastSlide = slideEls[slideEls.length - 1];
      var prefixSlide = lastSlide.cloneNode(true);
      prefixSlide.removeAttribute("data-tc-slide");
      prefixSlide.setAttribute("aria-hidden", "true");
      var suffixSlide = firstSlide.cloneNode(true);
      suffixSlide.removeAttribute("data-tc-slide");
      suffixSlide.setAttribute("aria-hidden", "true");
      slides.insertBefore(prefixSlide, firstSlide);
      slides.appendChild(suffixSlide);
      stageOffset = 1;
      slides.style.transform = "translateX(-100%)";
    }

    if (thumbsWrap && origThumbs.length > 1) {
      var prefixFrag = document.createDocumentFragment();
      var suffixFrag = document.createDocumentFragment();
      origThumbs.forEach(function (t, i) {
        var p = t.cloneNode(true);
        p.classList.remove("is-active");
        p.removeAttribute("data-tc-thumb");
        p.setAttribute("data-tc-thumb-clone", String(i));
        p.setAttribute("tabindex", "-1");
        p.setAttribute("aria-hidden", "true");
        prefixFrag.appendChild(p);
        var s = t.cloneNode(true);
        s.classList.remove("is-active");
        s.removeAttribute("data-tc-thumb");
        s.setAttribute("data-tc-thumb-clone", String(i));
        s.setAttribute("tabindex", "-1");
        s.setAttribute("aria-hidden", "true");
        suffixFrag.appendChild(s);
      });
      thumbsWrap.insertBefore(prefixFrag, thumbsWrap.firstChild);
      thumbsWrap.appendChild(suffixFrag);
      thumbPos = thumbLoop;
    }

    function thumbEl(domIndex) {
      return thumbsWrap ? thumbsWrap.children[domIndex] : null;
    }
    function thumbTargetLeft(el) {
      if (!el || !thumbsWrap) return 0;
      return thumbsWrap.scrollLeft + (el.getBoundingClientRect().left - thumbsWrap.getBoundingClientRect().left);
    }
    function thumbsLooped() {
      return !!(thumbsWrap && thumbLoop > 1 && thumbsWrap.children.length > thumbLoop * 2);
    }
    function nearestThumbPos(logical) {
      if (!thumbsLooped()) return logical;
      var cands = [logical, thumbLoop + logical, 2 * thumbLoop + logical];
      var best = cands[0];
      var bestDist = Math.abs(cands[0] - thumbPos);
      for (var c = 1; c < cands.length; c++) {
        var d = Math.abs(cands[c] - thumbPos);
        if (d < bestDist) {
          bestDist = d;
          best = cands[c];
        }
      }
      return best;
    }
    function markThumbs(logical) {
      if (!thumbsWrap) return;
      var mod = thumbLoop || 1;
      Array.prototype.forEach.call(thumbsWrap.children, function (t, i) {
        t.classList.toggle("is-active", (i % mod) === logical);
      });
    }
    function finishThumbReseat() {
      if (thumbReseat == null || !thumbsWrap) return;
      var el = thumbEl(thumbReseat);
      if (!el) {
        thumbReseat = null;
        thumbsWrap.classList.remove("is-scrolling");
        thumbsWrap.style.scrollSnapType = "";
        return;
      }
      thumbsWrap.classList.add("is-scrolling");
      thumbsWrap.style.scrollSnapType = "none";
      thumbsWrap.scrollTo({ left: thumbTargetLeft(el), behavior: "auto" });
      thumbPos = thumbReseat;
      thumbReseat = null;
      requestAnimationFrame(function () {
        thumbsWrap.classList.remove("is-scrolling");
        thumbsWrap.style.scrollSnapType = "";
      });
    }
    function reseatThumbLoop() {
      if (!thumbsLooped()) return;
      var real0 = thumbEl(thumbLoop);
      var suffix0 = thumbEl(thumbLoop * 2);
      if (!real0 || !suffix0) return;
      var width = suffix0.getBoundingClientRect().left - real0.getBoundingClientRect().left;
      if (width <= 1) return;
      var start = thumbTargetLeft(real0);
      var sl = thumbsWrap.scrollLeft;
      if (sl < start - 1) {
        thumbsWrap.scrollTo({ left: sl + width, behavior: "auto" });
      } else if (sl >= start + width - 1) {
        thumbsWrap.scrollTo({ left: sl - width, behavior: "auto" });
      }
    }
    function scrollThumbTo(domIndex, instant) {
      if (!thumbsWrap) return;
      var el = thumbEl(domIndex);
      if (!el) return;
      thumbPos = domIndex;
      if (thumbsLooped() && (domIndex < thumbLoop || domIndex >= thumbLoop * 2)) {
        thumbReseat = thumbLoop + (domIndex % thumbLoop);
      } else {
        thumbReseat = null;
      }
      thumbsWrap.classList.add("is-scrolling");
      thumbsWrap.style.scrollSnapType = "none";
      if (instant) {
        thumbsWrap.scrollTo({ left: thumbTargetLeft(el), behavior: "auto" });
        finishThumbReseat();
        return;
      }
      thumbsWrap.scrollTo({ left: thumbTargetLeft(el), behavior: "smooth" });
      window.clearTimeout(thumbScrollTimer);
      var idle = 0;
      var last = thumbsWrap.scrollLeft;
      function watch() {
        var sl = thumbsWrap.scrollLeft;
        if (Math.abs(sl - last) < 0.5) {
          idle += 1;
          if (idle >= 4) {
            finishThumbReseat();
            reseatThumbLoop();
            return;
          }
        } else {
          idle = 0;
          last = sl;
        }
        thumbScrollTimer = window.setTimeout(watch, 50);
      }
      thumbScrollTimer = window.setTimeout(watch, 80);
    }
    if (thumbsWrap) {
      thumbsWrap.addEventListener("scrollend", function () {
        window.clearTimeout(thumbScrollTimer);
        finishThumbReseat();
        reseatThumbLoop();
      });
    }
    function setStageVisual(visual, animate) {
      if (!slides) return;
      if (!animate) {
        slides.style.transition = "none";
        slides.style.transform = "translateX(" + (-visual * 100) + "%)";
        void slides.offsetWidth;
        slides.style.transition = "";
      } else {
        slides.style.transition = "";
        slides.style.transform = "translateX(" + (-visual * 100) + "%)";
      }
    }
    function finishStageReseat() {
      if (stageReseat == null) return;
      setStageVisual(stageReseat, false);
      stageReseat = null;
    }
    function applyIndex(next, thumbDom, instant) {
      if (!count) return;
      var from = idx;
      idx = ((next % count) + count) % count;
      markThumbs(idx);
      var wrappingForward = from === count - 1 && idx === 0;
      var wrappingBack = from === 0 && idx === count - 1;
      var visual = stageOffset + idx;
      stageReseat = null;
      if (!instant && stageOffset) {
        if (wrappingForward) {
          visual = stageOffset + count;
          stageReseat = stageOffset;
        } else if (wrappingBack) {
          visual = 0;
          stageReseat = stageOffset + count - 1;
        }
      }
      setStageVisual(visual, !instant);
      if (stageReseat != null) {
        window.clearTimeout(stageTimer);
        stageTimer = window.setTimeout(finishStageReseat, 380);
      }
      var tPos;
      if (typeof thumbDom === "number") tPos = thumbDom;
      else if (instant) tPos = (thumbsLooped() ? thumbLoop : 0) + idx;
      else tPos = nearestThumbPos(idx);
      scrollThumbTo(tPos, !!instant);
    }
    function go(n, instant) {
      applyIndex(n, null, instant);
    }
    if (slides) {
      slides.addEventListener("transitionend", function (e) {
        if (e.target !== slides) return;
        if (e.propertyName && e.propertyName !== "transform") return;
        window.clearTimeout(stageTimer);
        finishStageReseat();
      });
    }
    if (thumbsWrap) {
      thumbsWrap.addEventListener("click", function (e) {
        var btn = e.target.closest(".tc-hero__thumb");
        if (!btn || !thumbsWrap.contains(btn)) return;
        var i = Array.prototype.indexOf.call(thumbsWrap.children, btn);
        if (i < 0) return;
        applyIndex(count ? i % count : i, i, false);
      });
    }
    if (slides) {
      var startX = 0, dx = 0;
      slides.addEventListener("touchstart", function (e) { startX = e.touches[0].clientX; dx = 0; }, { passive: true });
      slides.addEventListener("touchmove", function (e) { dx = e.touches[0].clientX - startX; }, { passive: true });
      slides.addEventListener("touchend", function () {
        if (dx < -40) go(idx + 1, false);
        else if (dx > 40) go(idx - 1, false);
      });
    }
    requestAnimationFrame(function () { go(0, true); });

    var shipsDate = root.querySelector("[data-tc-ships-date]");
    var shipsDays = Number(root.getAttribute("data-ships-days") || cfg.shipsDays || 7);
    if (shipsDate) shipsDate.textContent = formatLongDate(addDays(new Date(), shipsDays));

    var form = root.querySelector("[data-tc-form]");
    var idInput = root.querySelector("[data-tc-id-input]");
    var planInput = root.querySelector("[data-tc-plan-input]");
    var atcBtn = root.querySelector("[data-tc-atc]");
    var atcPrice = root.querySelector("[data-tc-atc-price]");
    var atcCompare = root.querySelector("[data-tc-atc-compare]");
    var oneBtn = root.querySelector("[data-tc-onetime]");
    var subBtn = root.querySelector("[data-tc-sub-toggle]");
    var subCadence = root.querySelector("[data-tc-sub-cadence]");

    function current() { return variants[state.variantId] || variants[defaultId] || {}; }
    function unitPrice(v) {
      var price = Number(v.price || 0);
      if (state.subscribe) {
        if (variantPricing && v.sub != null) return Number(v.sub);
        if (discount > 0) price = Math.round(price * (100 - discount) / 100);
      }
      return price;
    }
    function displayPrice(v) {
      return unitPrice(v);
    }
    function cadenceLabel(v) {
      return v.cadenceLabel || "";
    }
    function compareFor(packVar) {
      if (variantPricing) return Number(packVar.compare || 0);
      var bottles = Number(packVar.bottles || 0);
      if (bottles > 0 && baseCents > 0) return bottles * baseCents;
      return Number(packVar.compare || 0);
    }
    var perSuffix = root.getAttribute("data-tc-per-suffix") || "";
    var subSaveEls = root.querySelectorAll("[data-tc-sub-save]");
    var subOnlyEls = root.querySelectorAll("[data-tc-sub-only]");
    function ensurePlanInput() {
      if (!form) return planInput;
      var live = form.querySelector("[data-tc-plan-input]");
      if (!live) {
        live = document.createElement("input");
        live.type = "hidden";
        live.setAttribute("data-tc-plan-input", "");
        form.appendChild(live);
      }
      planInput = live;
      if (form.hasAttribute("data-loop-product-id")) form.removeAttribute("data-loop-product-id");
      return live;
    }
    function planNodes() {
      var nodes = [];
      function add(el) {
        if (!el || !el.isConnected || nodes.indexOf(el) !== -1) return;
        nodes.push(el);
      }
      add(ensurePlanInput());
      if (form) {
        form.querySelectorAll("input[data-tc-plan-input], input[name='selling_plan']").forEach(add);
      }
      root.querySelectorAll("input[data-tc-plan-input], input[name='selling_plan']").forEach(add);
      return nodes;
    }
    function applyPlan(el, activePlan) {
      if (!el) return;
      if (state.subscribe && activePlan) {
        if (el.getAttribute("name") !== "selling_plan") el.setAttribute("name", "selling_plan");
        if (el.disabled) {
          el.disabled = false;
          el.removeAttribute("disabled");
        }
        if (String(el.value) !== activePlan) el.value = activePlan;
        if (el.getAttribute("value") !== activePlan) el.setAttribute("value", activePlan);
      } else {
        if (el.value) el.value = "";
        if (el.getAttribute("value")) el.setAttribute("value", "");
        if (!el.disabled) {
          el.disabled = true;
          el.setAttribute("disabled", "disabled");
        }
        if (el.hasAttribute("name")) el.removeAttribute("name");
      }
    }
    var planWriteLock = false;
    function writePlanInput(activePlan) {
      if (planWriteLock) return;
      planWriteLock = true;
      try {
        activePlan = String(activePlan || "");
        planNodes().forEach(function (el) { applyPlan(el, activePlan); });
        window.__tcOfferPlan = state.subscribe ? activePlan : "";
      } finally {
        planWriteLock = false;
      }
    }
    function schedulePlanWrite() {
      writePlanInput(String(state.planId || ""));
      [0, 40, 160, 400].forEach(function (ms) {
        setTimeout(function () { writePlanInput(String(state.planId || "")); }, ms);
      });
    }
    if (form && !form._tcPlanGuard) {
      form._tcPlanGuard = true;
      var formMo = new MutationObserver(function () {
        writePlanInput(String(state.planId || ""));
      });
      formMo.observe(form, { childList: true, subtree: true, attributes: true, attributeFilter: ["value", "name", "disabled"] });
    }
    function render() {
      syncPlan();
      var v = current();
      var price = displayPrice(v);
      var compare = compareFor(v);
      root.querySelectorAll("[data-tc-pack]").forEach(function (pack) {
        var id = pack.getAttribute("data-variant-id");
        pack.classList.toggle("is-selected", id === state.variantId);
        var input = pack.querySelector("input");
        if (input) input.checked = id === state.variantId;
        var packVar = variants[id];
        if (!packVar) return;
        var p = unitPrice(packVar);
        var priceEl = pack.querySelector("[data-tc-pack-price]");
        var cmpEl = pack.querySelector("[data-tc-pack-compare]");
        var saveEl = pack.querySelector("[data-tc-pack-save]");
        var packCmp = compareFor(packVar);
        if (priceEl) priceEl.textContent = money(p);
        var perEl = pack.querySelector("[data-tc-pack-per]");
        if (perEl) perEl.textContent = money(Math.round(p / Math.max(1, Number(packVar.bottles || 1)))) + perSuffix;
        if (saveEl) {
          var save = Math.max(0, packCmp - p);
          saveEl.textContent = savePrefix + " " + money(save);
        }
        if (cmpEl) {
          var showCmp = packCmp > p;
          cmpEl.textContent = showCmp ? money(packCmp) : "";
          if (showCmp) cmpEl.removeAttribute("hidden");
          else cmpEl.setAttribute("hidden", "hidden");
        }
      });
      if (oneBtn) oneBtn.classList.toggle("is-active", state.subscribe ? false : true);
      if (subBtn) subBtn.classList.toggle("is-active", state.subscribe);
      if (subCadence) {
        var c = cadenceLabel(v);
        var subFallback = root.getAttribute("data-sub-fallback") || "";
        subCadence.textContent = c && subFallback ? (c + ". " + subFallback) : (c || subFallback);
      }
      if (subSaveEls.length) {
        var one = Number(v.price || 0);
        var sub = v.sub != null ? Number(v.sub) : one;
        var pct = one > 0 ? Math.floor(((one - sub) * 100) / one) : 0; // rounded down: never overstated
        subSaveEls.forEach(function (el) { el.textContent = String(pct); });
      }
      subOnlyEls.forEach(function (el) { el.hidden = !state.subscribe; });
      if (oneBtn) oneBtn.setAttribute("aria-pressed", state.subscribe ? "false" : "true");
      if (subBtn) subBtn.setAttribute("aria-pressed", state.subscribe ? "true" : "false");
      if (idInput) idInput.value = state.variantId;
      var activePlan = String(state.planId || "");
      schedulePlanWrite();
      if (atcPrice) atcPrice.textContent = money(price);
      if (atcCompare) {
        var show = compare > price;
        atcCompare.textContent = show ? money(compare) : "";
        if (show) atcCompare.removeAttribute("hidden");
        else atcCompare.setAttribute("hidden", "hidden");
      }
      window.__tcOffer = {
        variantId: state.variantId,
        priceCents: price,
        compareCents: compare,
        subscribe: state.subscribe,
        sellingPlanId: state.subscribe ? activePlan : ""
      };
      document.dispatchEvent(new CustomEvent("tc:offer-change", { detail: window.__tcOffer }));
    }

    root.querySelectorAll("[data-tc-pack]").forEach(function (pack) {
      pack.addEventListener("click", function () {
        state.variantId = pack.getAttribute("data-variant-id");
        state.planId = pack.getAttribute("data-plan-id") || planFor(state.variantId);
        render();
      });
    });
    if (subBtn) subBtn.addEventListener("click", function () { state.subscribe = true; render(); });
    if (oneBtn) oneBtn.addEventListener("click", function () { state.subscribe = false; render(); });
    initAccordions(root);

    function afterAddDestination() {
      return String(root.getAttribute("data-tc-after-atc") || "checkout").toLowerCase();
    }
    function openUpCartDrawer() {
      if (typeof window.upcartOpenCart === "function") {
        window.upcartOpenCart();
        return;
      }
      document.dispatchEvent(new CustomEvent("cart:updated", { bubbles: true }));
      var bag = document.querySelector("a.tc-pdp-header__cart");
      if (bag) bag.click();
    }
    function goToCheckout() {
      window.location.assign("/checkout");
    }
    function postAdd(e) {
      if (e) {
        e.preventDefault();
        if (e.stopImmediatePropagation) e.stopImmediatePropagation();
        e.stopPropagation();
      }
      if (atcBtn.disabled) return;
      atcBtn.disabled = true;
      syncPlan();
      if (idInput) idInput.value = state.variantId;
      schedulePlanWrite();
      if (root.getAttribute("data-tc-mute-upcart") === "true") {
        // Same switch as the VSL order page (radiancy-buy.js muteUpCart): no drawer flash before /checkout.
        try {
          var ucs = window.upcartSettings && window.upcartSettings.upcartSettings;
          if (ucs) ucs.openOnAddToCart = false;
        } catch (err) { /* app not present */ }
      }
      var item = { id: Number(state.variantId), quantity: 1 };
      if (state.subscribe && state.planId) item.selling_plan = Number(state.planId);
      window.__tcLastAddReq = item;
      fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify({ items: [item] })
      })
        .then(function (r) {
          window.__tcLastAddStatus = r.status;
          if (!r.ok) throw new Error("add failed");
          return r.json().catch(function () { return {}; });
        })
        .then(function (json) {
          window.__tcLastAdd = json;
          atcBtn.disabled = false;
          if (window.__tcNoRedirect) return;
          if (afterAddDestination() === "drawer") {
            openUpCartDrawer();
            setTimeout(openUpCartDrawer, 80);
          } else {
            goToCheckout();
          }
        })
        .catch(function (err) {
          window.__tcLastAddError = String(err);
          atcBtn.disabled = false;
        });
    }
    if (form) form.addEventListener("submit", postAdd, true);
    if (atcBtn) atcBtn.addEventListener("click", postAdd, true);
    render();
    schedulePlanWrite();
  }

  function initAccordions(root) {
    root.querySelectorAll("[data-tc-acc-btn]").forEach(function (btn) {
      if (btn.dataset.tcAccBound === "1") return;
      btn.dataset.tcAccBound = "1";
      btn.addEventListener("click", function () {
        var item = btn.closest("[data-tc-acc-item]");
        if (!item) return;
        var group = item.parentElement;
        var wasOpen = item.classList.contains("is-open");
        if (group) {
          group.querySelectorAll("[data-tc-acc-item].is-open").forEach(function (openEl) {
            openEl.classList.remove("is-open");
            var b = openEl.querySelector("[data-tc-acc-btn]");
            if (b) b.setAttribute("aria-expanded", "false");
          });
        }
        if (wasOpen === false) {
          item.classList.add("is-open");
          btn.setAttribute("aria-expanded", "true");
        }
      });
    });
  }

  function bindCarousel(track, cards, dots, prev, next) {
    if (!track || !cards.length) return;
    cards = Array.prototype.slice.call(cards);
    dots = Array.prototype.slice.call(dots || []);
    var index = 0;
    function setDot(i) {
      dots.forEach(function (d, n) { d.classList.toggle("is-active", n === i); });
    }
    function stepSize() {
      var a = cards[0].getBoundingClientRect();
      var w = a.width || track.clientWidth || 1;
      var gap = 12;
      if (cards.length > 1) {
        var b = cards[1].getBoundingClientRect();
        var g = b.left - a.right;
        if (g > 0.5) gap = g;
        else {
          var cs = window.getComputedStyle(track);
          var parsed = parseFloat(cs.columnGap || cs.gap);
          if (parsed > 0) gap = parsed;
        }
      }
      return w + gap;
    }
    function currentIndex() {
      var step = stepSize();
      var i = Math.round((track.scrollLeft || 0) / step);
      if (i < 0) i = 0;
      if (i > cards.length - 1) i = cards.length - 1;
      return i;
    }
    var programmatic = false;
    var releaseTimer = 0;
    function go(i) {
      if (i < 0) i = 0;
      if (i > cards.length - 1) i = cards.length - 1;
      index = i;
      var sl = i * stepSize();
      programmatic = true;
      track.style.scrollSnapType = "none";
      void track.offsetWidth;
      track.scrollLeft = sl;
      setDot(i);
      requestAnimationFrame(function () {
        track.style.scrollSnapType = "";
      });
      clearTimeout(releaseTimer);
      releaseTimer = setTimeout(function () { programmatic = false; }, 80);
    }
    dots.forEach(function (dot, i) {
      dot.addEventListener("click", function (e) {
        e.preventDefault();
        go(i);
      });
    });
    if (prev) {
      prev.addEventListener("click", function (e) {
        e.preventDefault();
        go(index - 1);
      });
    }
    if (next) {
      next.addEventListener("click", function (e) {
        e.preventDefault();
        go(index + 1);
      });
    }
    track.addEventListener("scroll", function () {
      if (programmatic) {
        setDot(index);
        return;
      }
      index = currentIndex();
      setDot(index);
    }, { passive: true });
  }

  function initWall(root) {
    bindCarousel(
      root.querySelector("[data-tc-wall-track]"),
      root.querySelectorAll("[data-tc-wall-card]"),
      root.querySelectorAll("[data-tc-wall-dot]"),
      root.querySelector("[data-tc-wall-prev]"),
      root.querySelector("[data-tc-wall-next]")
    );
  }

  function initReasons(root) {
    bindCarousel(
      root.querySelector("[data-tc-reasons-track]"),
      root.querySelectorAll("[data-tc-reasons-card]"),
      root.querySelectorAll("[data-tc-reasons-dot]"),
      root.querySelector("[data-tc-reasons-prev]"),
      root.querySelector("[data-tc-reasons-next]")
    );
  }

  function initSticky(root) {
    var packs = document.getElementById("pack-selector");
    var hero = document.querySelector("[data-tc-kind='hero']");
    var trigger = packs || hero;
    function onScroll() {
      if (!trigger) {
        root.classList.add("is-visible");
        return;
      }
      var rect = trigger.getBoundingClientRect();
      root.classList.toggle("is-visible", rect.bottom < 64);
    }
    window.addEventListener("scroll", onScroll, { passive: true });
    onScroll();
    var shop = root.querySelector("[data-tc-sticky-shop]");
    if (shop) {
      shop.addEventListener("click", function () {
        var target = document.getElementById("pack-selector") || document.querySelector("[data-tc-atc]");
        if (target) { var y = target.getBoundingClientRect().top + window.pageYOffset - 80; window.scrollTo({ top: y, behavior: "smooth" }); }
      });
    }
  }

  function fixSvgPaths(scope) {
    var root = scope && scope.querySelectorAll ? scope : document;
    root.querySelectorAll("path[d]").forEach(function (p) {
      var d = p.getAttribute("d");
      if (!d || d.indexOf("- ") === -1) return;
      var next = d.replace(/([AaCc])-\s+/g, "$1-");
      if (next !== d) p.setAttribute("d", next);
    });
  }

  function scan(scope) {
    var root = scope || document;
    if (root.querySelectorAll) {
      root.querySelectorAll("[data-tc-kind]").forEach(boot);
    }
    if (root.getAttribute && root.getAttribute("data-tc-kind")) boot(root);
    fixSvgPaths(root);
  }
  [400, 1200, 2500].forEach(function (ms) {
    setTimeout(function () { fixSvgPaths(document); }, ms);
  });

  window.__tcPdpScan = scan;
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () { scan(document); });
  } else {
    scan(document);
  }
  document.addEventListener("shopify:section:load", function (e) { scan(e.target); });
})();
